import React from "react";
import "./coach-landing.css";

/**
 * Confianza para la landing de entrenadores, SIN testimonios inventados.
 *
 * ⚠️ Hasta el 1-oct-2026 aquí había tres testimonios con nombres de mentira
 * («Valentina R.», «Alejandra M.»…), y uno decía «Generé mis primeros 150 €»,
 * que además promete ingresos al coach (prohibido: el coach no gana dinero con
 * Wayo, solo deja de pagar). Un profesional que compara software reconoce un
 * testimonio de relleno, y es lo primero que quita credibilidad.
 *
 * En su lugar, lo que una empresa pequeña tiene y Harbiz no: hablar con el
 * fundador. Y el bloque «pregúntale a la IA» que Harbiz tiene en su pie: abre
 * ChatGPT, Claude, Perplexity o Google con la pregunta ya escrita.
 *
 * Cuando haya coaches reales que den permiso, sus frases van aquí, con nombre.
 */
const PREGUNTA_IA =
  "Soy entrenador personal. ¿Por qué debería usar Wayo Coach (wayoai.app/coaches) para gestionar a mis clientes, sus rutinas y sus planes de nutrición? Explícame cómo funciona, qué cuesta y cómo empiezo.";

const q = encodeURIComponent(PREGUNTA_IA);
const ASISTENTES = [
  { nombre: "ChatGPT", url: `https://chatgpt.com/?prompt=${q}` },
  { nombre: "Claude", url: `https://claude.ai/new?q=${q}` },
  { nombre: "Perplexity", url: `https://www.perplexity.ai/search?q=${q}` },
  { nombre: "Google IA", url: `https://www.google.com/search?udm=50&q=${q}` },
];

export default function CoachLandingTestimonials() {
  return (
    <section className="testimonials-section" id="fundador">
      <div className="container">
        <div className="testimonials-header">
          <div className="section-tag">Quién hay detrás</div>
          <h2 className="section-title">Aquí te contesta el fundador, no un bot</h2>
        </div>
        <div className="testimonials-grid fundador-grid">
          <div className="testimonial-card fundador-card">
            <p className="testimonial-text">
              Mi nombre es Facu y soy el fundador y CEO de WayoAI. Hemos hecho Wayo Coach para que
              un entrenador, un box o un centro tenga un software profesional sin pagar una cuota
              cada mes. Si tienes cualquier duda antes de empezar, escríbeme y te respondo yo.
            </p>
            <div className="testimonial-author" style={{ flexDirection: "column", alignItems: "center", gap: "8px" }}>
              <div className="testimonial-avatar">F</div>
              <div style={{ textAlign: "center" }}>
                <div className="testimonial-name">Facu</div>
                <div className="testimonial-role">Fundador y CEO de WayoAI</div>
              </div>
            </div>
            <div className="fundador-contacto">
              <a href="mailto:soporte@wayoai.app?subject=Wayo%20Coach">soporte@wayoai.app</a>
              <a href="https://www.instagram.com/facunfit/" target="_blank" rel="noopener noreferrer">
                Instagram @facunfit
              </a>
            </div>
          </div>

          <div className="testimonial-card fundador-card">
            <div className="fundador-ia-titulo">¿Prefieres una opinión de fuera?</div>
            <p className="testimonial-text">
              Pregúntale a tu IA de confianza por qué usar Wayo Coach. Te abrimos la pregunta ya
              escrita.
            </p>
            <div className="fundador-ia-botones">
              {ASISTENTES.map(({ nombre, url }) => (
                <a key={nombre} href={url} target="_blank" rel="noopener noreferrer">
                  {nombre}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
